<template>
  <div class="SelectServiceContract" :style="SelectServiceContractStyle">
    <div class="tabWrap">
      <div class="approve-rule">
        <span @click="SeeApproveRule">查看合同审批制度</span>
      </div>
      <el-tabs style="width: 100%" v-model="activeName">
        <el-tab-pane label="基本信息" name="first" class="firstTab">
          <div class="screenPanel">
            <el-form
              ref="ruleForm"
              :model="dialogForm"
              label-width="150px"
              :inline="true"
            >
              <el-row>
                <el-col :span="12">
                  <el-form-item label="合同分类">
                    <el-select
                      v-model="dialogForm.type"
                      filterable
                      default-first-option
                      placeholder="请选择"
                      disabled
                    >
                      <el-option label="劳务合同" value="LABOR"></el-option>
                      <el-option label="机械合同" value="MACHINE"></el-option>
                      <el-option label="材料合同" value="MATERIAL"></el-option>
                      <el-option label="其它" value="OTHERS"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="合同编号">
                    <el-input
                      v-model="dialogForm.serialNumber"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="合同名称">
                    <el-input
                      v-model="dialogForm.name"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="合同内容">
                    <el-input
                      v-model="dialogForm.content"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="我方单位">
                    <el-input
                      v-model="dialogForm.partyA"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="主要相对方单位">
                    <el-input
                      v-model="dialogForm.partyB"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="其它相对方单位">
                    <el-input
                      type="textarea"
                      :rows="2"
                      v-model="otherPartyBIds"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="所属项目">
                    <el-input
                      v-model="dialogForm.projectName"
                      :readonly="true"
                    ></el-input>
                    <!-- <el-select
                        v-model="dialogForm.projectId"
                        placeholder="-请选择-"
                        filterable
                        default-first-option
                        disabled="true"
                      >
                        <el-option
                          :label="item.name"
                          :value="item.id"
                          v-for="(item,index) in ProjectNameList"
                          :key="index"
                        ></el-option>
                    </el-select>-->
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="签订日期">
                    <el-date-picker
                      v-model="dialogForm.signDate"
                      type="date"
                      placeholder="请选择日期"
                      value-format="yyyy-MM-dd"
                      :readonly="true"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="合同金额">
                    <el-input v-model="dialogForm.amount" :readonly="true"
                      ><template slot="prepend">计算值:</template></el-input
                    >
                    <el-input v-model="dialogForm.amountShow" :readonly="true"
                      ><template slot="prepend">显示值:</template></el-input
                    >
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item label="不含税价">
                    <el-input
                      v-model="dialogForm.amountWithoutTax"
                      :readonly="true"
                      ><template slot="prepend">计算值:</template></el-input
                    >
                    <el-input
                      v-model="dialogForm.amountWithoutTaxShow"
                      :readonly="true"
                      ><template slot="prepend">显示值:</template></el-input
                    >
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="税率">
                    <el-input
                      v-model="dialogForm.taxRate"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="税金">
                    <el-input v-model="dialogForm.amountTax" :readonly="true"
                      ><template slot="prepend">计算值:</template></el-input
                    >
                    <el-input
                      v-model="dialogForm.amountTaxShow"
                      :readonly="true"
                      ><template slot="prepend">显示值:</template></el-input
                    >
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="合同期限">
                    <el-input
                      v-model="dialogForm.contractPeriod"
                      :readonly="true"
                    ></el-input>
                    <!-- <el-date-picker
                      v-model="dialogForm.contractPeriod"
                      type="date"
                      placeholder="请选择日期"
                      value-format="yyyy-MM-dd"
                      disabled
                    ></el-date-picker> -->
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="合同份数">
                    <el-input
                      size="medium"
                      v-model="dialogForm.copies"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="采购方式">
                    <el-select
                      v-model="dialogForm.purchaseType"
                      filterable
                      default-first-option
                      placeholder="请选择"
                      disabled
                    >
                      <el-option
                        v-for="item in typeOption"
                        :key="item.label"
                        :label="item.value"
                        :value="item.label"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="合同重要约定">
                    <el-input
                      type="textarea"
                      :rows="3"
                      placeholder="请输入内容"
                      v-model="dialogForm.agreeOn"
                      style="width: 100%"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <el-row>
                    <el-col style="padding-left: 150px" :span="8">
                      <el-checkbox
                        v-model="checkedone"
                        style="width: 100px"
                        label="1"
                        :disabled="true"
                        >是否预付款？</el-checkbox
                      >
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="预付款比例">
                        <el-input
                          v-model="dialogForm.advancePayPct"
                          :readonly="true"
                        >
                          <i slot="suffix">%</i>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="付款比例">
                        <el-input
                          v-model="dialogForm.advancePayPctAct"
                          :readonly="true"
                        >
                          <i slot="suffix">%</i>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col style="padding-left: 150px" :span="8">
                      <el-checkbox
                        v-model="checkedtwo"
                        style="width: 100px"
                        label="1"
                        :disabled="true"
                        >单价合同</el-checkbox
                      >
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="预估合同金额">
                        <el-input
                          v-model="dialogForm.predictPrice"
                          :readonly="true"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="预估合同数量">
                        <el-input
                          v-model="dialogForm.predictAmount"
                          :readonly="true"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col style="padding-left: 150px" :span="8">
                      <el-checkbox
                        v-model="checkedthree"
                        style="width: 100px"
                        label="0"
                        :disabled="true"
                        >总价合同</el-checkbox
                      >
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="合同金额">
                        <el-input
                          v-model="dialogForm.totalAmount"
                          :readonly="true"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="备注">
                    <el-input
                      type="textarea"
                      :rows="2"
                      placeholder="请输入内容"
                      v-model="dialogForm.comments"
                      maxlength="566"
                      size="medium"
                      style="width: 100%; min-width: 566px"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="申请人">
                    <el-input
                      size="medium"
                      v-model="dialogForm.applyUserName"
                      :editable="false"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="申请部门">
                    <el-input
                      size="medium"
                      v-model="dialogForm.applyDeptName"
                      :editable="false"
                      :readonly="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <el-form-item label="单据状态:">{{
                    dialogForm.approveStatusName
                  }}</el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="流水号:">{{
                    dialogForm.flowNo
                  }}</el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="单据日期:">{{
                    dialogForm.createTime
                  }}</el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-tab-pane>

        <el-tab-pane
          label="内部定额表"
          name="second"
          style="text-align: left"
          class="firstTab1"
          v-if="dialogForm.type == 'LABOR'"
        >
          <itemList
            :engineerItems="dialogForm.subContractQuotaDetailsVOs"
            :contractType="dialogForm.type"
            :pointSettingDto="dialogForm.pointSettingDto"
          ></itemList>
        </el-tab-pane>
        <el-tab-pane
          label="物资清单"
          name="third"
          style="text-align: left"
          class="firstTab1"
          v-else-if="dialogForm.type == 'MATERIAL'"
        >
          <GoodList
            :goodItems="dialogForm.subContractMaterialDetailsVOs"
            :contractType="dialogForm.type"
            :pointSettingDto="dialogForm.pointSettingDto"
          ></GoodList>
        </el-tab-pane>
        <el-tab-pane
          label="内部定额表"
          name="second"
          style="text-align: left"
          class="firstTab1"
          v-else
        >
          <QuotaList
            :engineerItems="dialogForm.subContractQuotaDetailsVOs"
            :contractType="dialogForm.type"
            :pointSettingDto="dialogForm.pointSettingDto"
          ></QuotaList>
        </el-tab-pane>
        <!--
        LABOR劳务 MATERIAL材料  MACHINE机械 3 机械 OTHERS其它
        劳务分项合同 对用劳务合同模板；   	LaborContract                     劳动合同          A    type==LABOR
        材料分项合同基本信息有复选框 选择单价合同对应物资合同单价-模板
        MaterialProcurementContract       物资采购合同 单价  B    type==MATERIAL    priceType==1
        材料分项合同基本信息有复选框 选择总价合同对应物资合同总价模板
        MaterialProcurementTotalContract  物资采购合同 总价  C    type==MATERIAL    priceType==2
        机械分项合同 对应 运输合同模板；		CarriageContract                  运输合同          D    type==MACHINE
        -->
        <el-tab-pane
          label="生成合同"
          name="ten"
          style="text-align: left; width: 60%"
        >
          <!-- <el-button
            type="info"
            @click="choiceTemplate"
            style="position: absolute; left: 400px; margin-top: 10px"
            >选择合同模板</el-button
          > -->
          <component
            :is="comName"
            :ref="comName"
            :templateKey="templateKey"
            :dialogForm="dialogForm"
            :subServiceContractId="subServiceContractId || 0"
          ></component>
        </el-tab-pane>
        <el-tab-pane
          label="附件"
          name="fourth"
          style="text-align: left"
          class="firstTab"
        >
          <div v-if="dialogForm.purchaseType != 'directBuy'">
            <div class="Contractfile">会议纪要</div>
            <upLoadFileDialog
              v-if="dialogForm.purchaseType != 'directBuy'"
              :itemVOs="dialogForm.conferenceItemVOs"
              :itemId="subServiceContractId"
              :isUploadAllowed="dialogForm.isUploadAllowed"
              :approveStatus="dialogForm.approveStatus"
              :type="mettingType"
              @saveUpdateFile="
                getsubServiceContractDetail(subServiceContractId)
              "
            ></upLoadFileDialog>
          </div>
          <div>
            <div class="Contractfile" style="margin-top: 24px">其他附件</div>
            <!-- <upLoadFileDialog
              :contractItemVOs="dialogForm.contractItemVOs"
            ></upLoadFileDialog> -->
            <upLoadFileDialog
              :itemVOs="dialogForm.contractItemVOs"
              :itemId="subServiceContractId"
              :approveStatus="dialogForm.approveStatus"
              :isUploadAllowed="dialogForm.isUploadAllowed"
              :type="approveType"
              @saveUpdateFile="
                getsubServiceContractDetail(subServiceContractId)
              "
            ></upLoadFileDialog>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="审批流程"
          name="fivth"
          style="text-align: left"
          class="firstTab"
        >
          <div v-if="approveFlag === 'currentApprove'">
            <approveItem
              :itemId="subServiceContractId"
              :approveType="approveType"
              :subapproveType="subapproveType"
              @finishApprove="close1"
            >
            </approveItem>
          </div>
          <div v-else>
            <approveLine
              :itemId="subServiceContractId"
              :approveType="approveType"
            ></approveLine>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="补充协议"
          name="sixth"
          style="text-align: left"
          class="firstTab"
          v-if="dialogForm.appendSubContracts.length > 0"
        >
          <addContractProtocol
            :contractScanVOs="dialogForm.appendSubContracts"
            :subServiceContractId="subServiceContractId"
          ></addContractProtocol>
        </el-tab-pane>
        <el-tab-pane
          label="审签表"
          name="seventeen"
          style="text-align: left"
          class="firstTab1"
          v-if="dialogForm.approveStatus == 3"
        >
          <ApproveAndSign
            :itemId="subServiceContractId"
            :approveType="approveType"
          ></ApproveAndSign>
        </el-tab-pane>
        <el-tab-pane
          label="工程量清单"
          name="eighteen"
          style="text-align: left; width: auto"
          class="firstTab1"
          v-if="dialogForm.approveStatus == 3 && dialogForm.type != 'MATERIAL'"
        >
          <projectQuotaList
            :engineerItems="dialogForm.subContractQuotaDetailsVOs"
            :goodItems="dialogForm.subContractMaterialDetailsVOs"
            :contractType="dialogForm.type"
            :dialogForm="dialogForm"
          ></projectQuotaList>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="bottomBtn">
      <el-button type="info" @click="close1">关 闭</el-button>
    </div>
  </div>
</template>

<script>
import {
  getServiceContractDetailService, //获取一条劳务合同项目信息
} from "@/services/allContractServices";
import {
  getBidTypeDic, //获取一级数据字典接口
} from "@/services/bidServices";
import { numFilter } from "@/utils/filters";
import QuotaList from "./selectQuotaList"; //劳务合同工程量清单tab页
import GoodList from "./selectGoodList"; //采购合同物资清单tab页
import projectQuotaList from "./sprojectQuotaList"; //劳务合同工程量清单tab页
import itemList from "./selectItemList.vue";
import approveLine from "@/page/approveComponents/ApproveHistoryLine"; //历史审批流程
import approveItem from "@/page/approveComponents/ApproveItem"; //审批流程
import upLoadFileDialog from "@/components/upLoadFileDialog"; //附件列表
import addContractProtocol from "./addContractProtocol"; //补充协议列表
// import CombinedContract from "../template/CombinedContract"; //生成合同CombinedContract
// import CombinedContract from "../template/CombinedContract2"; //生成劳务合同CombinedContract
// import buyCombinedContract from "../template/CombinedContract1"; //生成采购合同CombinedContract
import noTemplate from "../template/noTemplate"; //其他合同无合同模板
import LaborContract from "../template/LaborContract"; //劳务合同 A
import MaterialProcurementContract from "../template/MaterialProcurementContract"; //B 物资采购合同 单价
import MaterialProcurementTotalContract from "../template/MaterialProcurementTotalContract"; //C 物资采购合同 总价
import CarriageContract from "../template/CarriageContract"; //D运输合同
import mudMixContract from "../template/machine/mudMixContract"; //稳定土拌合加工合同
import asphaltMixContract from "../template/machine/asphaltMixContract"; //沥青拌合加工合同
import machinLeaseContract from "../template/machine/machinLeaseContract"; //机械租赁合同
import concretMixContract from "../template/machine/concretMixContract"; //混凝土拌合加工运输合
import transportContract from "../template/machine/transportContract"; //拌合料运输合同
import carRentalContract from "../template/carRentalContract"; //其他合同-汽车租赁合同模板
import transportbhlContract from "../template/machine/transportbhlContract"; //运输合同—适用于各种拌合料
import concreteMakeMixContract from "../template/machine/concreteMakeMixContract"; //混凝土拌合加工合同
import ApproveAndSign from "./ApproveAndSign"; //审签表
import { goBackApprove } from "@/page/approveComponents/approve";

export default {
  name: "SelectServiceContract",
  components: {
    approveLine, //审批历史流程
    approveItem, //审批
    addContractProtocol, //追加补充协议列表
    GoodList,
    // CombinedContract, //打印劳务合同
    // buyCombinedContract, //打印物资采购
    QuotaList, //工程量清单
    projectQuotaList,
    itemList, //内部定额表跟工程量清单合并组件
    upLoadFileDialog, //上传附件
    LaborContract, // A劳务合同
    MaterialProcurementContract, // B 物资采购合同 单价
    MaterialProcurementTotalContract, // C 物资采购合同 总价
    CarriageContract, //  D运输合同
    mudMixContract, //稳定土拌合加工合同
    machinLeaseContract, //机械租赁合同
    transportContract, //拌合料运输合同
    asphaltMixContract, //沥青拌合加工合同
    concretMixContract, //混凝土拌合加工运输合同
    carRentalContract, //汽车租赁合同模板
    transportbhlContract,
    concreteMakeMixContract,
    ApproveAndSign, //  审签表
    noTemplate,
  },
  data() {
    return {
      activeName: "first", //活动tab页
      templateKey: "detail",
      approveType: "SUB_CONTRACT", //审批类型
      mettingType: "MENTTING", //会议纪要附件类型
      subapproveType: "subContract", // 审批子类型
      approveFlag: "", //false：查看 true：审批
      addFlag: false, //true:追加补充协议
      ProjectNameList: [], //所属项目下拉框
      category: "PROJECT_NAME", //下拉列表类型，默认为项目名称
      FinanceClassifyList: [], //财务分类下拉列表
      EngineerClassifyList: [], //工程分类下拉列表
      FinanceList: [], //财务一级下拉列表
      subDeptList: [], //部门列表
      typeOption: [], //采购方式下拉列表数据
      currentUserId: "",
      applyUserDiaVisible: false, //选择申请人弹窗
      subServiceContractId: 0, //存储获取劳务合同id
      checkedone: false,
      checkedtwo: false,
      checkedthree: false,
      comName: "", //组件名称
      otherPartyBIds: "",
      dialogForm: {
        id: 0,
        pcontractId: 0, //如果是补充协议，存储分项合同id
        serialNumber: "", // 合同编号
        name: "", //合同名称
        partyA: "", //合同甲方
        partyB: "", //合同乙方
        advancePayPct: "", //预付款比例
        advancePayPctAct: "", //付款比例
        amountTax: "", //税金
        amountTaxShow: "", //税金
        amountWithoutTax: "", //除税合同金额
        amountWithoutTaxShow: "", //除税合同金额
        applyDeptId: "", //申请人部门ID
        applyDeptName: "", //申请人部门名称
        applyUserId: 0, //申请人ID
        applyUserName: "", //申请人姓名
        approveStatus: null, //审批状态编码
        approveStatusName: "", //审批状态名称
        approveUserId: "", //当前审批人
        signDate: "", //签订日期
        signPlace: "", //签订地点
        amount: 0.0, //合同金额
        amountShow: 0.0, //合同金额
        comments: "", //备注
        agreeOn: "", //付款约定
        content: "", //合同内容
        contractPeriod: "", //合同期限
        predictAmount: "", //单价合同预估数量
        predictPrice: "", //单价合同预估金额
        priceType: 0, //1单价合同 2总价合同
        isAdvancePay: 0, //是否预付款
        projectId: "", //所属项目id
        taxRate: "", //税率
        totalAmount: "", //总价合同总金额
        type: "LABOR", //分项合同类型，LABOR劳务 MATERIAL材料  MACHINE机械 3 机械 OTHERS其它
        updateTime: "",
        contractItemVOs: [],
        subContractMaterialDetailsVOs: [], //物资采购合同 物资明细列表 劳务合同添加物资清单数据
        appendSubContracts: [], //追加协议列表
        contractScanVOs: [], //合同扫描件
        purchaseType: "", //采购方式 20220112
        subContractQuotaDetailsVOs: [], //内部定额表 20220112
        conferenceItemVOs: [], //会议纪要附件列表 20220112
      },
      SelectServiceContractStyle: { height: 100 + "%" },
    };
  },
  created() {
    this.getbidPlanType(); //获取采购方式下拉列表
    this.currentUserId = sessionStorage.getItem("currentUserId");
  },
  mounted() {
    let ch3 = document.documentElement.clientHeight - 60;
    this.$set(this.SelectServiceContractStyle, "height", ch3 + "px");

    window.onresize = () => {
      return (() => {
        let ch4 = document.documentElement.clientHeight - 60;
        this.$set(this.SelectServiceContractStyle, "height", ch3 + "px");
      })();
    };
  },
  methods: {
    //获取路由跳转传参
    onActive() {
      this.activeName = "first";
      this.templateKey += 1;
      console.log(this.templateKey);
      this.approveFlag = this.tabRouteParam?.approveFlag ?? "";
      this.subServiceContractId = this.tabRouteParam.id;
      this.getsubServiceContractDetail(this.subServiceContractId);
      if (this.tabRouteParam.routeId == "approveDetail") {
        //补充追加协议
        this.addFlag = true;
        this.dialogForm.pcontractId = this.subServiceContractId;
      }
      // if (this.tabRouteParam.routeId == "innerApproveDetail") {
      //   //编辑追加协议
      //   this.subServiceContractId = this.tabRouteParam.id; //存储补充协议id
      //   this.dialogForm.pcontractId = this.tabRouteParam.pid;
      // }
    },

    close() {
      let that = this;
      this.$router.back();
    },
    //获取一条劳务合同信息
    getsubServiceContractDetail(id) {
      let param = {};
      param.id = id;
      this.checkedone = false;
      this.checkedtwo = false;
      this.checkedthree = false;
      this.dialogForm.advancePayPct = "";
      this.dialogForm.advancePayPctAct = "";
      this.dialogForm.predictPrice = ""; //预估合同金额
      this.dialogForm.predictAmount = ""; //预估合同数量
      this.dialogForm.totalAmount = ""; //总价合同

      getServiceContractDetailService(param)
        .then((res) => {
          if (res.code == 10000000) {
            this.dialogForm = res.data;
            this.dialogForm.contractPeriod =
              (this.dialogForm.contractPeriodStart || "") +
              " 至 " +
              this.dialogForm.contractPeriod;
            if (this.dialogForm.isAdvancePay == 1) {
              this.checkedone = true;
            }
            if (this.dialogForm.priceType == 1) {
              this.checkedtwo = true;
            } else if (this.dialogForm.priceType == 2) {
              this.checkedthree = true;
            } else {
              this.checkedtwo = false;
              this.checkedthree = false;
            }
            let ss = this.dialogForm.subContractPrintVO?.templateType ?? "";
            if (ss && ss != "DEFAULT") {
              this.comName = ss;
            } else {
              this.saveTemplateFun();
            }
            if (
              this.dialogForm.otherPartyBList &&
              this.dialogForm.otherPartyBList.length > 0
            ) {
              this.otherPartyBIds = this.dialogForm.otherPartyBList.map(
                (em) => {
                  return em.partyB;
                }
              );
            }
            this.dialogForm.contractItemVOs = res.data.contractItemVOs;
            this.dialogForm.type = this.dialogForm.type.toString();
            if (this.dialogForm.type == "LABOR") {
              this.dialogForm.subContractQuotaDetailsVOs =
                this.dialogForm.subContractUnionDetailsVOList;
            } else if (this.dialogForm.type != "MATERIAL") {
              this.dialogForm.subContractMaterialDetailsVOs = [];
            }
            this.Fornmat(0);
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$alert(error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    //存储合同模板
    saveTemplateFun(type) {
      this.templateType = type;
      //LABOR劳务 MATERIAL材料  MACHINE机械 3 机械 OTHERS其它
      switch (this.dialogForm.type) {
        case "LABOR":
          this.comName = "LaborContract";
          break;
        case "MATERIAL": //材料合同默认单价
          if (this.dialogForm.priceType == 2)
            //总价
            this.comName = "MaterialProcurementTotalContract";
          else this.comName = "MaterialProcurementContract"; //单价
          break;
        case "MACHINE":
          this.comName = "carriageContract";
          break;
        case "OTHERS":
          this.comName = "LaborContract";
      }
    },

    //查看合同审批制度
    SeeApproveRule() {
      this.bus.$emit("navMenuChange", {
        routeId: "ContractApproveRule",
      });
    },
    close1() {
      if (this.approveFlag) {
        goBackApprove(this.approveFlag, "totalApproveList");
        return;
      } else {
        this.bus.$emit("tabClose", "totalApproveList");
      }
      if (this.dialogForm.type == "LABOR") {
        //分项合同类型，LABOR劳务 MATERIAL材料  MACHINE机械 3 机械 OTHERS其它
        this.bus.$emit("navMenuChange", {
          routeId: "payment-orderCheck",
        });
      } else if (this.dialogForm.type == "MATERIAL") {
        this.bus.$emit("navMenuChange", {
          routeId: "buyContract",
        });
      } else if (this.dialogForm.type == "MACHINE") {
        this.bus.$emit("navMenuChange", {
          routeId: "machineryContractMag",
        });
      } else {
        this.bus.$emit("navMenuChange", {
          routeId: "otherContract",
        });
      }
    },
    Fornmat(val) {
      if (this.dialogForm.amount) {
        this.dialogForm.amount = numFilter(this.dialogForm.amount);
      } else this.dialogForm.amount = "0.00";
      if (this.dialogForm.amountWithoutTax) {
        this.dialogForm.amountWithoutTax = numFilter(
          this.dialogForm.amountWithoutTax
        );
      } else this.dialogForm.amountWithoutTax = "0.00";

      if (this.dialogForm.amountTax) {
        this.dialogForm.amountTax = numFilter(this.dialogForm.amountTax);
      } else this.dialogForm.amountTax = "0.00";
      if (this.dialogForm.predictPrice) {
        this.dialogForm.predictPrice = numFilter(this.dialogForm.predictPrice);
      }
      if (this.dialogForm.totalAmount) {
        this.dialogForm.totalAmount = numFilter(this.dialogForm.totalAmount);
      }
    },
    //获取采购计划类型下拉框数据
    getbidPlanType() {
      getBidTypeDic().then(
        (res) => {
          if (res.code == 10000000) {
            // this.total = res.total;
            this.typeOption = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$alert("系统异常", "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.SelectServiceContract {
  background-color: white;
  height: 100%;
  overflow: hidden;

  .tabWrap {
    height: calc(100% - 60px);
    //  /deep/.el-tabs__item.is-top.is-active {
    //   background-color: #ffffff;
    // }
    /deep/ .el-tabs--top {
      height: 100%;
      overflow: hidden;

      .el-tabs__content {
        height: calc(100% - 40px);
        padding: 0 20px 20px;
        overflow: auto;

        .el-form-item {
          width: 100%;
        }

        .el-checkbox {
          line-height: 40px;
        }

        .el-textarea {
          min-width: 0px !important;
        }

        .el-form-item__content {
          width: calc(100% - 150px);

          .el-input {
            width: 100%;
          }
        }
      }
    }
    .Contractfile {
      height: 44px;
      // padding-left: 24px;
      margin-bottom: 24px;
      box-shadow: 0px 1px 0px 0px rgba(238, 238, 238, 1);
      border-radius: 2px 2px 0px 0px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.85);
      line-height: 44px;
      text-align: left;
    }
  }

  .bottomBtn {
    position: fixed;
    left: 640px;
    width: 800px;
    height: 60px;
    line-height: 60px;
  }
}
/deep/.ApproveItem .bottomBtn {
  bottom: 21px;
  z-index: 10;
  left: 500px;
}
/deep/ .el-tabs__item {
  padding: 0 20px !important;
}
.screenPanel {
  text-align: left;
  height: auto;
  padding-bottom: 16px;
  margin-top: 20px;
  border-bottom: 1px solid #e6e6e6;
}

.operatePanel {
  text-align: left;
  margin: 20px 60px;
}

.el-select {
  width: 100%;
}
.approve-rule {
  color: red;
  /* text-align: right; */
  position: absolute;
  right: 30px;
  top: 20px;
  height: 40px;
  display: flex;
  align-items: center;
  z-index: 1;
}
/deep/.el-header {
  position: relative;
}
.btnList {
  text-align: center;
  margin-top: 20px;
}
.el-form-item {
  margin-bottom: 14px;
}

.time-box {
  //  display: flex;
  // height: 180px;
  overflow-y: auto;
  flex: 1;
  .item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 10px;
  }
}
.left {
  width: 320px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 10px;
}
.right {
  height: 32px;
  line-height: 32px;
  width: 60px;
  text-align: center;
  cursor: pointer;
}
.add {
  background-color: #00cccc;
  border-radius: 2px;
  color: #ecf5ff;
}
.el-select {
  margin-right: 10px;
}

/deep/.el-date-editor--time {
  width: 130px;
}
/deep/ .el-tabs__header {
  padding-right: 0px !important;
}
.firstTab1 {
  width: 92%;
}
.firstTab {
  width: 72%;
}
@media only screen and(max-width:1680px) {
  .firstTab {
    width: 90%;
  }
  .firstTab1 {
    width: 100%;
  }
}
</style>

<style scoped>
.hidden >>> .el-upload--picture-card {
  display: none;
}
</style>
